var vF14 = function () {
  return this;
}();
try {
  vF14 = vF14 || new Function("return this")();
} catch (e34) {
  if (typeof window == "object") {
    vF14 = window;
  }
}
module.exports = vF14;